/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_DictateInputs */



/**
* | output |
* | --- |
* | "Speak your message" |
*
* @param {Chat_DictateInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate = /** @type {((inputs?: Chat_DictateInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_DictateInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Inspreken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dicter votre message")
	return /** @type {LocalizedString} */ ("Speak your message")
});